import { CampaignV2Status } from '@/services/endpoints/campaigns/types';

export type CampaignListStatus = 'active' | 'paused' | 'completed' | 'scheduled' | 'draft';

export const STATUS_STYLES: Record<CampaignListStatus, string> = {
  active: 'bg-emerald-100 text-emerald-700',
  paused: 'bg-amber-100 text-amber-700',
  completed: 'bg-slate-200 text-slate-700',
  scheduled: 'bg-sky-100 text-sky-700',
  draft: 'bg-slate-100 text-slate-700',
};

export const STATUS_LABELS: Record<CampaignListStatus, string> = {
  active: 'Active',
  paused: 'Paused',
  completed: 'Completed',
  scheduled: 'Scheduled',
  draft: 'Draft',
};

export const mapCampaignStatus = (status: CampaignV2Status): CampaignListStatus => {
  if (status === 'ACTIVE') {
    return 'active';
  }
  if (status === 'PAUSED') {
    return 'paused';
  }
  if (status === 'COMPLETED') {
    return 'completed';
  }
  if (status === 'SCHEDULED') {
    return 'scheduled';
  }

  return 'draft';
};
